import React from "react";

import { va_total_fee, va_total_add_to_loan } from "../../../calculations/loan";

import { UPFRONT_FUND_FEE } from "../../../constants/va_constants";

import SelectField from "../../fields/select_field";
import CurrencyField from "../../fields/currency_field";
import { useDocument } from "../loan_tool";

export default function VAPricingTool({ loan, updateLoan, readOnly }) {
  const [{ property }, , { documentType }] = useDocument();
  const { va_upfront_funding_fee, va_add_to_loan } = loan;
  return (
    <div className="va-pricing-tool">
      <div className="down-payment-section-title">VA Pricing Tool </div>
      <SelectField
        title="LANIS Training Tip: Use the chart to determine the VA Upfront Funding Fee. If the Veteran has been classified as having a Disability as a result of their Service, the Funding Fee may be waived. Make sure you ask the questions and collect the necessary VA paperwork."
        fieldName="va_upfront_funding_fee"
        value={va_upfront_funding_fee}
        name="VA Upfront Funding Fee"
        onChange={updateLoan}
        selectOptions={UPFRONT_FUND_FEE}
      />
      <CurrencyField
        name="Total Fee"
        readOnly
        value={va_total_fee(documentType, loan, property)}
      />
      <CurrencyField
        name="Add to Loan"
        fieldName="va_add_to_loan"
        readOnly={readOnly}
        value={va_add_to_loan}
        onChange={updateLoan}
      />
      <CurrencyField
        name="Total Add To Fees"
        readOnly
        value={va_total_add_to_loan(documentType, loan, property)}
      />
    </div>
  );
}
